import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
	selector: 'xp-avatar',
	standalone: true,
	imports: [CommonModule],
	templateUrl: './xp-avatar.component.html',
	styleUrls: ['./xp-avatar.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpAvatarComponent {
	imageUrl = input<string | null | undefined>(null);
	initials = input('');
	alt = input('');
}
